'use strict';

import cloudinary from 'cloudinary-core';
import { isPlainObject, isString } from 'lodash';

const regex = /(https?):\/\/(res.cloudinary.com)\/(?<cloud_name>[^/]+)\/(image|video|raw)\/(upload|authenticated)\/(.*)\/v(?<version>[0-9]+)\/(?<public_id>[^?]*)?/;

const instance = new cloudinary.Cloudinary({
    secure: true,
});

function validateImage(image) {
    if (isString(image)) {
        image = regex.exec(image).groups;
    }

    if (isPlainObject(image)) {
        return {
            public_id: image.public_id,
            cloud_name: image.cloud_name,
            version: image.version,
        }
    }

    return null;
}

export function transform(image, transformations) {
    image = validateImage(image);

    if (!image) {
        return null;
    }

    const { public_id, ...otherOptions } = image;

    return instance.url(public_id, {
        crop: 'fill',
        ...otherOptions,
        ...transformations,
    });
}

export default {
    transform,
}
